import axios from '../config/axios';

const GET_QRT = 'api/Questionnaire/trouverQuestionnaire';

export const getQrt = (id) => {
    return axios.get(GET_QRT, {
        params: {
            id: id,
        }
    });
};
